import { z } from 'zod';

export const editMemberSchema = z.object({
  externalId: z
    .string()
    .nullish()
    .default(null)
    .transform((val) => val || null),
  fullName: z.string().min(2, { message: 'Informe o nome do membro.' }),
  email: z.string().email(),
});

export type EditMemberForm = z.infer<typeof editMemberSchema>;
